import * as types from "./actionTypes";

export const setRelatedGroups = (relatedGroups) => ({
  type: types.SET_RELATED_GROUPS,
  payload: { relatedGroups }
});

export const setRelatedGroupsSearch = (relatedGroupsSearch) => ({
  type: types.SET_RELATED_GROUPS_SEARCH,
  payload: { relatedGroupsSearch }
});

export const toggleGalleryVisible = (galleryVisible, galleryShowActiveFeature = null) => ({
  type: types.TOGGLE_GALLERY_VISIBLE,
  payload: { galleryVisible, galleryShowActiveFeature }
});

export const setGalleryActiveImageIndex = (galleryActiveImageIndex) => ({
  type: types.SET_GALLERY_ACTIVE_IMAGE_INDEX,
  payload: { galleryActiveImageIndex }
});

export const setMaterialsPageSubSteps = (subSteps) => ({
  type: types.SET_MATERIALS_PAGE_SUB_STEPS,
  payload: { subSteps }
});

export const setMaterialsPageActiveSubStep = (activeSubStep) => ({
  type: types.SET_MATERIALS_PAGE_ACTIVE_SUB_STEP,
  payload: { activeSubStep }
});

export const toggleNotCompatibleView = (showNotCompatibleView) => ({
  type: types.TOGGLE_NOT_COMPATIBLE_VIEW,
  payload: { showNotCompatibleView }
});

export const toggleProductNoteEditorVisible = (productNoteEditorVisible) => ({
  type: types.TOGGLE_PRODUCT_NOTE_EDITOR_VISIBLE,
  payload: { productNoteEditorVisible }
});

export const setRowItems = (rowItems) => ({
  type: types.SET_ROW_ITEMS,
  payload: { rowItems }
});
export const setMaterialsCanvasClass = (materialsCanvasClass) => ({
  type: types.SET_MATERIALS_PAGE_CANVAS_CLASS,
  payload: { materialsCanvasClass }
});
export const setMaterialsCanvasLoading = (materialsCanvasLoading) => ({
  type: types.SET_MATERIALS_PAGE_CANVAS_LOADING,
  payload: { materialsCanvasLoading }
});
